import { mainApi } from '@/lib';
import { LOCAL_STORAGE_KEYS } from '@/lib/constants';

/**
 * Connects Google Calendar via OAuth redirect
 * Based on Vue implementation: defaultConnect() in IntegrationMixin.js
 */
export async function connectGoogleCalendar(returnUrl?: string): Promise<void> {
    try {
        setupTrackingIntegrationProgress('google-calendar');

        const payload = returnUrl ? { returnUrl } : {};
        const response = await mainApi.post('v1/integrations/google-calendar', payload);

        // Redirect to OAuth URL
        if (response.data?.url) {
            window.location.href = response.data.url;
        }
    } catch (error) {
        console.error('Failed to connect Google Calendar:', error);
        throw error;
    }
}

/**
 * Connects Zoom via OAuth redirect
 */
export async function connectZoom(returnUrl?: string): Promise<void> {
    try {
        setupTrackingIntegrationProgress('zoom');

        const payload = returnUrl ? { returnUrl } : {};
        const response = await mainApi.post('v1/integrations/zoom', payload);

        // Redirect to OAuth URL
        if (response.data?.url) {
            window.location.href = response.data.url;
        }
    } catch (error) {
        console.error('Failed to connect Zoom:', error);
        throw error;
    }
}

/**
 * Setup localStorage tracking for integration progress
 * This allows us to track when an integration is in progress
 */
function setupTrackingIntegrationProgress(integrationType: string): void {
    try {
        let integrationInProgress: Record<string, number> =
            JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.INTEGRATION_IN_PROGRESS) || '{}') || {};

        // Add or update the integration progress
        integrationInProgress = { ...integrationInProgress, [integrationType]: 1 };

        // Store the updated integration progress in localStorage
        localStorage.setItem(LOCAL_STORAGE_KEYS.INTEGRATION_IN_PROGRESS, JSON.stringify(integrationInProgress));
    } catch (error) {
        console.error('Failed to set integration tracking in localStorage:', error);
    }
}
